<ng-container *ngIf="!isOffline; else offline">
	<ng-container *ngIf="!isLoading else loading">
		<ng-container *ngIf="orders.length > 0">
			<div class="card-title">
				<span translate>favorite-orders.title</span>
			</div>
				<div class="flagged-orders-grid-portal">
					<ng-container *ngFor="let order of orders">			
						<a class="pill pill-clickable card-infos-center" [routerLink]="['/order-tracking/order/card', order.supplierOrderNumber, order.supplierOrderItemNumber]">{{getOrderName(order)}}</a>
						<div class="card-infos-text card-infos-center card-infos-overflow-wrap">{{getProductName(order)}}</div>
						<div class="card-infos-text card-infos-center">{{order | copoDimension}}</div>
					</ng-container>
				</div>
				<div class="flagged-orders-mobile">
					<ng-container *ngFor="let order of orders">
						<div class="flagged-orders-reference">
							<a class="pill pill-clickable card-infos-center" [routerLink]="['/order-tracking/order/card', order.supplierOrderNumber, order.supplierOrderItemNumber]">{{getOrderName(order)}}</a>
							<span class="card-infos-text card-infos-center">{{order | copoDimension}}</span>
						</div>
						<div class="card-infos-text card-infos-center">{{getProductName(order)}}</div>
					</ng-container>
				</div>
			<div class="card-block-footer mobile-hide">
				<button type="button" color="primary" (click)="viewDetails()" mat-button>
					<span translate>order-tracking.card.delivery-date.view-details</span>
					<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
				</button>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
<ng-template #offline>
	<copo-offline></copo-offline>
</ng-template>
<ng-template #loading>
	<copo-loading-spinner class="loading-spinner-small-container"></copo-loading-spinner>
</ng-template>
